export default __webpack_public_path__ + "static/analytics_scene-0bab135b912481bcd313290921c8bb7d.glb";